export enum ChatWigetType {
    Sidebar = 'sidebar',
    Floating = 'floating',
    ChannelView = 'channel-view',
    Host = 'host',
    FullScreen = 'full-screen',
}
